<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.83301 11C1.83301 5.93737 5.93707 1.83331 10.9997 1.83331C16.0623 1.83331 20.1663 5.93737 20.1663 11C20.1663 16.0626 16.0623 20.1666 10.9997 20.1666C5.93707 20.1666 1.83301 16.0626 1.83301 11ZM14.3088 15.2793C14.5767 15.5473 15.0111 15.5473 15.279 15.2793C15.5469 15.0114 15.5469 14.577 15.279 14.3091L11.6857 10.7158V6.78419C11.6857 6.40528 11.3786 6.09811 10.9997 6.09811C10.6208 6.09811 10.3136 6.40528 10.3136 6.78419V11C10.3136 11.1819 10.3859 11.3564 10.5146 11.4851L14.3088 15.2793Z"
      fill=""
    />
  </svg>
</template>

<style scoped lang="scss"></style>
